import { resolveTheme } from '../../designTokens';

export default function EmptyState({ theme, title, message, icon, cta }) {
  const t = theme || resolveTheme();
  return (
    <div style={{
      border: `1px dashed ${t.card_border}`,
      borderRadius: '10px',
      padding: '32px 22px',
      textAlign: 'center',
    }}>
      {icon && (
        <div style={{ marginBottom: '12px', display: 'flex', justifyContent: 'center' }}>
          {icon}
        </div>
      )}
      {title && <p style={{ margin: '0 0 4px', fontWeight: '600', color: '#374151', fontSize: '0.95em' }}>{title}</p>}
      {message && <p style={{ margin: 0, color: t.text_secondary, fontSize: '0.875em' }}>{message}</p>}
      {cta && <div style={{ marginTop: '16px' }}>{cta}</div>}
    </div>
  );
}
